import { baseApi } from 'shared/api/baseApi'
import { INDIVIDUAL_USER, USER, USERS_TAG } from 'shared/api/tags'
import type {
    AuthResponse,
    RequestLoginBody,
    RequestRegistrationBody,
    RequestResetPasswordBody,
    RequestResetPasswordConfirmationBody,
} from './types'

enum AuthURLs {
    SIGN_IN = '/auth/sign-in',
    SIGN_UP = '/auth/sign-up',
    RESET_PASSWORD_REQUEST = '/auth/reset-password-request',
    RESET_PASSWORD = '/auth/reset-password',
}

export const sessionApi = baseApi.injectEndpoints({
    endpoints: (build) => ({
        login: build.mutation<AuthResponse, RequestLoginBody>({
            query: (body) => ({
                url: AuthURLs.SIGN_IN,
                method: 'POST',
                body,
            }),
        }),
        signUp: build.mutation<AuthResponse, RequestRegistrationBody>({
            query: (body) => ({
                url: AuthURLs.SIGN_UP,
                method: 'POST',
                body,
            }),
            invalidatesTags: [USER, INDIVIDUAL_USER, USERS_TAG],
        }),
        resetPassword: build.mutation<void, RequestResetPasswordBody>({
            query: (body) => ({
                url: AuthURLs.RESET_PASSWORD_REQUEST,
                method: 'POST',
                body,
            }),
        }),
        resetPasswordConfirmation: build.mutation<
            void,
            RequestResetPasswordConfirmationBody
        >({
            query: (body) => ({
                url: AuthURLs.RESET_PASSWORD,
                method: 'POST',
                body,
            }),
        }),
    }),
})

export const {
    useLoginMutation,
    useResetPasswordMutation,
    useResetPasswordConfirmationMutation,
} = sessionApi
